/* tslint:disable */
/* eslint-disable */
/**
 * Import Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface PublisherDTO
 */
export interface PublisherDTO  {
    /**
     * 
     * @type {number}
     * @memberof PublisherDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PublisherDTO
     */
    name?: string;
}

/**
 * Check if a given object implements the PublisherDTO interface.
 */
export function instanceOfPublisherDTO(value: object): value is PublisherDTO {
    return true;
}

export function PublisherDTOFromJSON(json: any): PublisherDTO {
    return PublisherDTOFromJSONTyped(json, false);
}

export function PublisherDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublisherDTO {
    if (json == null) {
        return json;
    }
    return {
        
                  'id': json['id'] == null ? undefined : json['id'],
                  'name': json['name'] == null ? undefined : json['name'],
    };
}

export function PublisherDTOToJSON(json: any): PublisherDTO {
    return PublisherDTOToJSONTyped(json, false);
}

export function PublisherDTOToJSONTyped(value?: PublisherDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}


